import { Component, OnInit } from '@angular/core';
import { NbMenuItem, NbMenuService } from '@nebular/theme';
import { DynamicInputComponent, MenuGroup } from '../dynamic-input-model';
import { EditorService } from '../services/editor.service';
import { FooterInputComponent } from './footer-input/footer-input.component';

@Component({
  selector: 'ngx-footer-editor',
  templateUrl: './footer-editor.component.html',
  styleUrls: ['./footer-editor.component.scss']
})
export class FooterEditorComponent implements OnInit {
  title = "Editing Footer";
  menuTag = "editFooterMenu";
  inputComponent = new DynamicInputComponent(FooterInputComponent);
  menuGroups:any;
  topLevelMenu:MenuGroup;
  secondaryMenus:MenuGroup[] = [];
  tertiaryMenus:MenuGroup[] = [];

  menuGroup:MenuGroup = {
    title:"Editing Footer",
    menuTag:"editFooterMenu",
    menuItems: [
      {
        title:'Footer Layout',
        children:[
          {
            title:'Corporate Info',
          },
          {
            title:'Commercial Policies',
          },
          {
            title:'Customer Relations',
          }
        ]
      },
      {
        title:'Sections',
        children:[
          {
            title:'Corporate Info',
          },
          {
            title:'Commercial Policies',
          },
          {
            title:'Customer Relations',
          }
        ]
      },
      {
        title:'Styling'
      }
    ] 
  }

  menuItems:NbMenuItem[] = []
  previousMenu:NbMenuItem[] = [];

  constructor(
    private editorService:EditorService,
    private menuService:NbMenuService) { }

  ngOnInit(): void {
    this.menuGroups = this.editorService.createMenusFromGroup(this.menuGroup);
    this.inputComponent.data = this.menuGroups;
    this.editorService.setInputComponent(this.inputComponent);
    console.log(this.menuGroups);
    this.menuService.onItemClick().subscribe(menuBag =>{
      console.log({menuBag:menuBag});
      let selectedItem = menuBag.item;
      if(selectedItem != undefined){
        //if(selectedItem.parent.title)
        this.setMenu(selectedItem);
        console.log({selectedItem:selectedItem});
      }
    })
  }
  setMenu(selectedItem:NbMenuItem){
    if(selectedItem.title == "Back"){
      this.menuItems = this.previousMenu;
    }else{
      this.menuGroup.menuItems.forEach(menuItem => {
        if(menuItem.title == selectedItem.title && menuItem.children != null){
          this.previousMenu = this.menuItems;
          console.log(menuItem.title);
          let backLinkLNbMenuItem = {title:"Back",icon:"arrow-back-outline"};
          let headerItem:NbMenuItem = {title:menuItem.title,group:true}
          this.menuItems = [backLinkLNbMenuItem,headerItem].concat(menuItem.children);
        }
      })
    }
    
  }

}
